let scroller;
let scrollPos;

var mainHeader = $('.cd-auto-hide-header'),
	secondaryNavigation = $('.cd-secondary-nav'),
	//this applies only if secondary nav is below intro section
	belowNavHeroContent = $('.sub-nav-hero'),
	headerHeight = mainHeader.height();
let scroll;
//set scrolling variables
var scrolling = false,
	previousTop = 0,
	currentTop = 0,
	currentScroll,
	scrollDelta = 10,
	scrollOffset = 100;
scrollOffset = 50;






autohideheader();


function autohideheader() {
	if ($('.wth_menu_theme_2').length) {
		mainHeader.addClass('menu_theme_2');
		$('footer').css('paddingBottom', 0);

	}
	//

	// jQuery(document).ready(function ($) {



		function menuShow() {
			$('body').addClass('body-in-blur');

		}

		function menuHide() {

			$('body').removeClass('body-in-blur');

		}
		$(".header .dropdown").on("show.bs.dropdown", function (event) {
			// var x = $(event.relatedTarget).text(); // Get the text of the element
			menuShow();


			let $menuItems = $(event.relatedTarget).parent().find('.dropdown-menu').find('.menuElement');
			let time = 20;
			$menuItems.each(function (i) {
				setTimeout(function () {
					$menuItems.eq(i).addClass('show');
				}, time)
				time += 100;
			});




		});

		$(".header .dropdown").on("hide.bs.dropdown", function (event) {
			menuHide();

			let $menuItems = $(event.relatedTarget).parent().find('.dropdown-menu').find('.menuElement').removeClass('show');


		});

		$(".navbar-toggler").click(function () {
			$(this).toggleClass('active');
			if ($(this).hasClass('active')) {
				menuShow();
				mainHeader.addClass('styled');

				menuHide();

			}
			$('body').toggleClass('menu-toggle');


		})
		$(".close-menu").click(function () {
			$(".navbar-toggler").removeClass('active');
			$('body').removeClass('menu-toggle');
			menuHide();

		})





		$('.hamburger').click(function () {
			$('.hamburger').toggleClass('is-active');
			$('.menu_accordion').toggleClass('is-active');

		})



		mainHeader.on('click', '.nav-trigger', function (event) {
			// open primary navigation on mobile
			event.preventDefault();
			mainHeader.toggleClass('nav-open');
		});

		if ((currentTop = previousTop)) { //this has been added by Elhamy
			mainHeader.removeClass('is-shown'); //this has been added by Elhamy
			//console.log('its at top') //this has been added by Elhamy
		} //this has been added by Elhamy





		$(window).on('scroll', function () {

			const elem = $('.has-contact-icons');

			let scrollPos = $(document).scrollTop();

			$('section').each(function () {
				if ($(window).scrollTop() + 150 > $(this).offset().top) {
					var blockID = $(this).attr('id');
					$('.sec-btn').removeClass('s-active').addClass('pre-active');
					$('.sec-btn').removeClass('active');
					$('.sec-btn[data-href="' + blockID + '"]').addClass("s-active");

					setTimeout(function () {
						$('.sec-btn').removeClass('pre-active');
					}, 200)					

				}
			})






			// $('.car-item').each(function () {
			// 	if($(window).scrollTop() + 150  > $(this).offset().top  ){
			// 		var blockID = $(this).attr('id');
			// 		$('.sec-btn').removeClass('active');
			// 		$('.sec-btn[data-href="' + blockID + '"]').addClass("active");
			// 	}
			// })






			// if (scrollPosa >= elem.offset().top +elem.outerHeight() + 300) {
			if (scrollPos >= elem.outerHeight() + 0) {

				$(".contact-icons.fixed").addClass('show');

			}
			if (scrollPos <= elem.outerHeight()) {
				$(".contact-icons.fixed").removeClass('show')

			}
			if (!scrolling) {
				scrolling = true;
				(!window.requestAnimationFrame) ?
				setTimeout(autoHideHeader, 250): requestAnimationFrame(autoHideHeader);

			}
		});


		function autoHideHeader() {
			//	var currentTop = scrollPos;
			var currentTop = $(window).scrollTop();

			(belowNavHeroContent.length > 0) ?
			checkStickyNavigation(currentTop) // secondary navigation below intro
				: checkSimpleNavigation(currentTop);

			previousTop = currentTop;
			scrolling = false;
		}
		//console.log('previousTop1', previousTop)
		//console.log('currentTop1', currentTop)

		function checkSimpleNavigation(currentTop) {
			//there's no secondary nav or secondary nav is below primary nav
			if (previousTop - currentTop > scrollDelta) {
				//if scrolling up...
				mainHeader.removeClass('is-hidden');
				mainHeader.addClass('is-shown'); //this has been added by Elhamy

				//console.log('scrollingup')
				//console.log('previousTop2', previousTop)
				//console.log('currentTop2', currentTop)
				addStyle();
			} else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
				//if scrolling down...
				mainHeader.addClass('is-hidden');
				mainHeader.removeClass('is-shown'); //this has been added by Elhamy

				// for hamburger menu
				$('.hamburger').removeClass('is-active');
				// for accordion menu
				$('.menu_accordion').removeClass('is-active');

				if (mainHeader.hasClass('nav-open')) { //this has been added by Elhamy
					mainHeader.removeClass('nav-open'); //this has been added by Elhamy

				} //this has been added by Elhamy
				//console.log('scrollingdown')
				//console.log('previousTop3', previousTop)
				//console.log('currentTop3', currentTop)
				addStyle();
			}
		}

		function addStyle() {
			var logo = $('.logo a img');
			var logoimg = $('.logo a img').attr('src');
			//console.log('logoimg', logoimg)
			if ((previousTop + currentTop > 500)) {
				mainHeader.addClass('styled');


				//  logoimg = logo.attr('src', logo_colored);
			} else {
				mainHeader.removeClass('styled');
				// logoimg = logo.attr('src', logo_white);
			}
		}

		function checkStickyNavigation(currentTop) {
			//secondary nav below intro section - sticky secondary nav
			var secondaryNavOffsetTop = belowNavHeroContent.offset().top - secondaryNavigation.height() - mainHeader.height();

			if (previousTop >= currentTop) {
				//if scrolling up... 
				if (currentTop < secondaryNavOffsetTop) {
					//secondary nav is not fixed
					mainHeader.removeClass('is-hidden');
					mainHeader.addClass('inscroll-top'); //this has been added by Elhamy
					secondaryNavigation.removeClass('fixed slide-up');
					belowNavHeroContent.removeClass('secondary-nav-fixed');
				} else if (previousTop - currentTop > scrollDelta) {
					//secondary nav is fixed
					mainHeader.removeClass('is-hidden');
					mainHeader.addClass('inscroll-top'); //this has been added by Elhamy
					secondaryNavigation.removeClass('slide-up').addClass('fixed');
					belowNavHeroContent.addClass('secondary-nav-fixed');
				}

			} else {
				//if scrolling down...	
				if (currentTop > secondaryNavOffsetTop + scrollOffset) {
					//hide primary nav
					mainHeader.addClass('is-hidden');
					mainHeader.removeClass('inscroll-top'); //this has been added by Elhamy
					secondaryNavigation.addClass('fixed slide-up');
					belowNavHeroContent.addClass('secondary-nav-fixed');
				} else if (currentTop > secondaryNavOffsetTop) {
					//once the secondary nav is fixed, do not hide primary nav if you haven't scrolled more than scrollOffset 
					mainHeader.removeClass('is-hidden');
					mainHeader.addClass('inscroll-top'); //this has been added by Elhamy
					secondaryNavigation.addClass('fixed').removeClass('slide-up');
					belowNavHeroContent.addClass('secondary-nav-fixed');
				}

			}
		}
	// });


	$('.sec-btn').click(function () {
		let dataScroll = $(this).data('href');

		$(this).siblings().removeClass('active');
		$(this).addClass('active');


		var targetEle = dataScroll;
		var $targetEle = $(targetEle);
		// window.location.hash = targetEle;
		$('html, body').stop().animate({
			'scrollTop': $('#' + targetEle).offset().top - 100
		}, 500, '', function () {

		});
	})



}
